const initialState = {items: [], disabled: false, errors: null}

const reservationEntity = (state = initialState, {type, payload}) => {
  switch (type) {
    case "RECURRING_RESERVATIONS.SUBMIT":
      return {...state, disabled: true}
    case "RECURRING_RESERVATIONS.ERROR":
      return {...state, disabled: false}
    case "RECURRING_RESERVATIONS.LOADED":
      return {...state, disabled: false, items: payload.recurringReservations, errors: payload.errors}
    case "RECURRING_RESERVATIONS.RESET_ERRORS":
      return {...state, errors: null}
  }
  return state
}

export default reservationEntity
